import type {AxiosRequestConfig} from 'axios';

export class GetFulfillmentVariantsBuilder {
  private readonly fulfillmentVariantsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/fulfillment-variants',
    params: {},
  };

  params(params: object) {
    this.fulfillmentVariantsRequest.params = params;
    return this;
  }

  id(id: number) {
    this.fulfillmentVariantsRequest.url = `/fulfillment-variants/${id}`;
    return this;
  }

  build() {
    return this.fulfillmentVariantsRequest;
  }
}

export class CreateFulfillmentVariantsBuilder {
  private readonly fulfillmentVariantsRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/fulfillment-variants',
    params: {},
  };

  data(data: object) {
    this.fulfillmentVariantsRequest.data = data;
    return this;
  }

  build() {
    return this.fulfillmentVariantsRequest;
  }
}
